import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import * as actions from './checkin-review.actions';
import { CheckinReviewState } from './checkin-review.state';

/**
 * checkinReview initial state
 */
export const checkinReviewInitialState: CheckinReviewState = {
  model: {},
};

/**
 * List of basic actions for CheckinReview Store
 */
export const checkinReviewReducerFeatures: ReducerTypes<CheckinReviewState, ActionCreator[]>[] = [
  on(actions.setCheckinReview, (_state, payload) => ({ ...payload })),

  on(actions.updateCheckinReview, (state, payload) => ({ ...state, ...payload })),

  on(actions.resetCheckinReview, () => checkinReviewInitialState),

  on(actions.updateDetailsOpenStatusByTraveler, (state, payload) => ({
    ...state,
    model: { ...state.model, ...payload },
  })),
];

/**
 * CheckinReview Store reducer
 */
export const checkinReviewReducer = createReducer(checkinReviewInitialState, ...checkinReviewReducerFeatures);
